import { ComparatorStep } from '@kizi/comparator-core';

const apply: ComparatorStep = {
  path: 'apply',
  name: 'apply',
  fields: [
    {
      name: 'wizardSteps',
      validator: 'required',
    },
    {
      name: 'orderId',
    },
  ],
};

export default apply;
